<template>
  <div>
    <p>
      The advisor profiles made available through this find-an-advisor directory
      (the “Directory”) may be considered to be an endorsement of such advisors
      as the term “endorsement” is defined in Rule 206(4)-1 of the Investment
      Advisers Act of 1940 (the “Marketing Rule”). XY Planning Network LLC
      (“XYPN”) is not a current client of any advisors appearing in the
      Directory.
    </p>

    <p>
      The existence and content of an advisor profile is not based on the actual
      experience of XYPN or any clients with such advisor, and is solely based
      on an advisor’s conformance with XYPN’s standard membership eligibility
      requirements. Advisors appearing in the Directory each pay an annual
      membership fee to XYPN, which is in consideration of a variety of services
      and benefits provided by XYPN to its advisor members – including the
      ability to be listed in the Directory. Due to the annual membership fees
      received from advisors, XYPN has a conflict of interest and a financial
      incentive to only include advisors in the Directory from whom XYPN has
      received compensation.
    </p>

    <p>
      XYPN encourages prospective clients of advisors listed in the Directory to
      independently evaluate such advisors based on additional criteria deemed
      appropriate.
    </p>
  </div>
</template>
